import { render } from "./Product-popup.vue?vue&type=template&id=1be9000a&scoped=true"
import script from "./Product-popup.vue?vue&type=script&lang=js"
export * from "./Product-popup.vue?vue&type=script&lang=js"

import "./Product-popup.vue?vue&type=style&index=0&id=1be9000a&scoped=true&lang=css"

import exportComponent from "/Volumes/DEXP W500C/homePc/актуально/new-dff/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be9000a"]])

export default __exports__